import {Alert} from "@mui/material";
import {useTranslation} from "react-i18next";

const ErrorPage = () => {
    const {t} = useTranslation();
    return (
        <Alert severity="error" sx={{mt: 2}}>
            {t('ERROR_PAGE_TEXT')}
        </Alert>
    )
}

export default ErrorPage;